export default __webpack_public_path__ + "static/Zipmex_logo-0b54db5d073336d99d377d2887496853.png";